import { Component, OnInit, ViewContainerRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { UserApi, LoopBackAuth, CommonApi } from '../../../../shared/sdk';
import { FrontLoginModalComponent } from "../../login/login-f-modal.component";
import { FrontResetPasswordModalComponent } from "../../login/reset-f-modal.component";
import { FrontSuccessModalComponent } from "../../login/success-f-modal.component";
import { Funciones } from "../../../../shared/funciones";
import { EmmitService } from '../../../../shared/componentes/emmit.service';

@Component({
  selector: 'app-front-header',
  templateUrl: './frontend-header.component.html',
  providers: [NgbDropdown]
})
export class FrontHeaderComponent implements OnInit, OnDestroy {

  public subscription: any;
  public navbarCollapsed: boolean = true;
  public info: boolean = false;
  public headerData: any;
  public searchTerm: string = '';
  public userData: any;
  public redirectTo: any;
  public searchType: number = 1;

  constructor(
    public commonapi: CommonApi,
    public userApi: UserApi,
    public funciones: Funciones,
    public auth: LoopBackAuth,
    public router: Router,
    public emmitservice: EmmitService,
    private modalService: NgbModal,
    public toastr: ToastsManager,
    public vcr: ViewContainerRef,
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.subscription = this.emmitservice.getData().subscribe((res: any) => {
      if (res.type == 'front-header' && res.msg == 'refresh-data') {
        this.getUserData();
      }
      if (res.type == 'front-header' && res.msg == 'refresh-orders') {
        this.getOrders();
      }
      if (res.type == 'front-header' && res.msg == 'show-login') {
        window.scrollTo(0, 0);
        this.userApi.logout();
        this.getUserData();
        if (res.redirectTo) {
          this.redirectTo = res.redirectTo;
        }
        setTimeout(() => {
          this.open();
        }, res.delay || 1500);
      }
    });
  }

  ngOnInit() {
    this.getUserData();
    this.getOrders();
    this.commonapi.getFrontHeader().subscribe(res => {
      this.headerData = res;
    });
  };

  getUserData() {
    let data = this.auth.getToken();
    let diff = this.funciones.getDateDiff(new Date(data.created));
    if (diff.days >= 1) {
      this.userApi.logout();
    }
    this.userData = data.user;
  };

  getOrders() {
    let ordenes = JSON.parse(window.localStorage.getItem('compras-libreria'));
    let prestamos = JSON.parse(window.localStorage.getItem('prestamos-biblioteca'));
    if ((ordenes && ordenes.length) || (prestamos && prestamos.length)) {
      this.info = true;
    }
  };

  eventHandler(e) {
    if (e.key == "Enter") {
      this.search();
    }
  };

  search() {
    if (this.searchType == 1) {
      this.router.navigate(['/libreria/busqueda', this.searchTerm]);
    } else {
      this.router.navigate(['/biblioteca/busqueda', this.searchTerm]);
    }
  }

  open() {
    const modalRef = this.modalService.open(FrontLoginModalComponent, { windowClass: 'front-login-modal' });
    modalRef.result.then(res => {
      if (res == 'registered-user') {
        this.confirmationModal('newUser');
      } else {
        this.getUserData();
        this.toastr.success('Sus credenciales son validas!', 'Todo correcto!');
        if (this.redirectTo) {
          this.router.navigate([this.redirectTo]);
          this.redirectTo = null;
        }
      }
    }, err => {
      if (err == 'reset-password') {
        this.resetPassword();
      } else if (err == 'invalid-user') {
        this.toastr.error('Su usuario o contraseña es invalida', 'Ingreso Incorrecto!!');
      }
    });
  };

  resetPassword() {
    const modalRef = this.modalService.open(FrontResetPasswordModalComponent, { windowClass: 'front-login-modal' });
    modalRef.result.then(res => {
      this.confirmationModal('reset');
    }, err => { });
  };

  confirmationModal(type) {
    const modalRef = this.modalService.open(FrontSuccessModalComponent, { windowClass: 'front-login-modal' });
    let temp = {};
    temp[type] = true;
    modalRef.componentInstance.data = temp;
    modalRef.result.then(res => { }, err => { });
  };

  logout() {
    let successLogout = () => {
      this.router.navigate(['/']);
      setTimeout(() => {
        this.toastr.info('Su sesión ha sido cerrada correctamente!', 'Todo correcto!');
        this.getUserData();
      }, 100);
    };

    this.userApi.logout().subscribe(res => {
      successLogout();
    }, err => {
      successLogout();
    });
  };

  ngOnDestroy() {
    this.subscription.unsubscribe();
  };

}



// WEBPACK FOOTER //
// ./src/app/modules/frontend/generic/frontend-header/frontend-header.component.ts